var $export = require('./_export');
$export($export.G + $export.W + $export.F * !require('./_typed').ABV, {
  DataView: require('./_typed-buffer').DataView
});



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/core-js/modules/es6.typed.data-view.js
// module id = q3b2
// module chunks = 1